import { PageLayout } from '~/components/PageLayout/PageLayout';
import { Schema } from './components/user-form.schema';
import { useCreateUserMutation } from '../mutations';
import { UserForm } from './components/user-form';
import { Fragment } from 'react/jsx-runtime';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router';

export function Page() {
  const mutation = useCreateUserMutation();
  const navigate = useNavigate();

  async function handleSubmit(payload: Schema) {
    await mutation.mutateAsync(payload);
    toast.success('Användaren har skapats');
    navigate('/admin/users');
  }

  return (
    <Fragment>
      <PageLayout.Heading text="Skapa användare" />
      <UserForm onSubmit={handleSubmit} mode="create" />
    </Fragment>
  );
}
